// extracted by mini-css-extract-plugin
export default {"iconBox":"ekhgHhfUhAOQLPuDcEqi","linkBox":"yEK3UeIPFKCeu0fJDDRp","label":"USNbll3VT7xRmhRPWld4","linkValue":"Aqu1Q8rPeqj6gqiLexlt"};